import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { founderProfile, founderEvents } from '../data/founder';

export function renderAbout(): string {
  const eventsHtml = founderEvents.map(evt => {
    const badgesHtml = evt.badges.map(b => /*html*/`
      <span class="badge badge-cyan" style="font-size: 0.72rem; padding: 0.2rem 0.55rem;">${b}</span>
    `).join('');

    return /*html*/`
      <div class="glass-panel" style="padding: 2rem; border-left: 4px solid #00f2fe; margin-bottom: 1.5rem;">
        <div style="display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap; gap: 0.75rem; margin-bottom: 0.75rem;">
          <div>
            <span style="font-size: 1.35rem; font-weight: 800; color: #00f2fe; margin-right: 0.6rem;">${evt.year}</span>
            <span style="font-size: 1.15rem; font-weight: 700; color: #ffffff;">${evt.title}</span>
          </div>
          <span style="font-size: 0.85rem; color: #94a3b8; display: inline-flex; align-items: center; gap: 0.35rem;">
            <sl-icon name="geo-alt"></sl-icon> ${evt.location}
          </span>
        </div>
        <div style="font-size: 0.9rem; color: #a855f7; font-weight: 600; margin-bottom: 0.75rem;">
          ${evt.role}
        </div>
        <p style="font-size: 0.95rem; color: #cbd5e1; line-height: 1.7; margin-bottom: 1.25rem;">
          ${evt.description}
        </p>
        <div style="display: flex; flex-wrap: wrap; gap: 0.4rem;">
          ${badgesHtml}
        </div>
      </div>
    `;
  }).join('');

  const expertiseHtml = founderProfile.expertise.map(item => /*html*/`
    <div style="display: flex; align-items: center; gap: 0.5rem; font-size: 0.88rem; color: #cbd5e1; background: rgba(255,255,255,0.03); padding: 0.6rem 0.85rem; border-radius: 8px; border: 1px solid rgba(255,255,255,0.06);">
      <span style="color: #00f2fe;">✦</span>
      <span>${item}</span>
    </div>
  `).join('');

  return /*html*/`
    ${Header()}
    
    <main class="fade-in">
      <!-- About Hero Header -->
      <section style="position: relative; padding: 5rem 0 4rem; overflow: hidden; background: radial-gradient(circle at 50% 20%, rgba(102, 126, 234, 0.15) 0%, rgba(7, 8, 13, 0.95) 75%); border-bottom: 1px solid rgba(255, 255, 255, 0.08);">
        <div class="container" style="position: relative; z-index: 1; text-align: center; max-width: 850px;">
          <div class="badge badge-purple" style="margin-bottom: 1rem;">
            <sl-icon name="stars"></sl-icon>
            <span>The AtomixM Vision</span>
          </div>
          <h1 style="font-size: clamp(2.2rem, 5vw, 3.5rem); margin-bottom: 1.25rem;">
            Mass & <span class="text-gradient">Multimedia Studio</span>
          </h1>
          <p style="font-size: 1.15rem; color: #cbd5e1; line-height: 1.7;">
            AtomixM was founded on a singular conviction: that the boundaries between code, gaming, generative music, and cinematic storytelling are dissolving into a unified canvas of digital creation.
          </p>
        </div>
      </section>

      <!-- Founder Spotlight & Career Story -->
      <section class="container" style="padding: 5rem 1.5rem 3rem;">
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(320px, 1fr)); gap: 3rem; align-items: start;">
          
          <!-- Founder Bio Card -->
          <div class="glass-panel" style="padding: 2.5rem; text-align: center; border-top: 3px solid #00f2fe;">
            <div style="position: relative; width: 170px; height: 170px; margin: 0 auto 1.5rem;">
              <img 
                src="${founderProfile.avatarUrl}" 
                alt="${founderProfile.name}" 
                style="width: 100%; height: 100%; border-radius: 50%; object-fit: cover; border: 3px solid #00f2fe; box-shadow: 0 0 30px rgba(0, 242, 254, 0.4);"
              />
              <div style="position: absolute; bottom: 6px; right: 6px; width: 36px; height: 36px; border-radius: 50%; background: #06d6a0; border: 2px solid #07080d; display: flex; align-items: center; justify-content: center; color: #07080d;">
                <sl-icon name="check-lg" style="font-size: 1.25rem;"></sl-icon>
              </div>
            </div>

            <h2 style="font-size: 1.75rem; color: #fff; margin-bottom: 0.35rem;">
              ${founderProfile.name}
            </h2>
            <div style="font-size: 0.95rem; color: #00f2fe; font-weight: 600; margin-bottom: 1.5rem;">
              ${founderProfile.title}
            </div>

            <p style="font-size: 0.92rem; color: #cbd5e1; line-height: 1.7; margin-bottom: 1.75rem; text-align: left;">
              ${founderProfile.bio}
            </p>

            <div style="display: flex; gap: 0.65rem; justify-content: center; flex-wrap: wrap;">
              <a href="${founderProfile.linkedinUrl}" target="_blank" rel="noopener noreferrer" class="btn-cyber" style="background: linear-gradient(135deg, #0077b5 0%, #0e76a8 100%); padding: 0.5rem 1rem; font-size: 0.85rem;">
                <sl-icon name="linkedin"></sl-icon>
                <span>LinkedIn Profile</span>
              </a>
              <a href="${founderProfile.githubProfile}" target="_blank" rel="noopener noreferrer" class="btn-ghost" style="padding: 0.5rem 1rem; font-size: 0.85rem;">
                <sl-icon name="github"></sl-icon>
                <span>GitHub (@atomixnmc)</span>
              </a>
              <a href="${founderProfile.devBlog}" target="_blank" rel="noopener noreferrer" class="btn-ghost" style="padding: 0.5rem 1rem; font-size: 0.85rem; border-color: rgba(0, 242, 254, 0.3); color: #38bdf8;">
                <sl-icon name="journal-code"></sl-icon>
                <span>mydevblog</span>
              </a>
            </div>
          </div>

          <!-- Atlanta Summit & Comic-Con Story -->
          <div>
            <div class="glass-panel" style="overflow: hidden; padding: 0; margin-bottom: 2rem;">
              <div style="position: relative; height: 210px;">
                <img 
                  src="${founderProfile.boothImage}" 
                  alt="Atlanta Comic Con & Game Summit Showcase" 
                  style="width: 100%; height: 100%; object-fit: cover;"
                />
                <div style="position: absolute; inset: 0; background: linear-gradient(180deg, transparent 30%, rgba(7, 8, 13, 0.95) 100%);"></div>
                <div style="position: absolute; bottom: 1rem; left: 1.5rem;">
                  <span class="badge badge-purple" style="margin-bottom: 0.35rem;">Atlanta Comic-Cons & Summits</span>
                  <div style="font-size: 1.2rem; font-weight: 700; color: #fff;">
                    Connecting with Creators & Developers in Atlanta
                  </div>
                </div>
              </div>
            </div>

            <h3 style="font-size: 1.5rem; color: #fff; margin-bottom: 1.25rem;">Milestones & Event Appearances</h3>
            ${eventsHtml}
          </div>

        </div>
      </section>

      <!-- Professional Expertise & Architecture Competencies -->
      <section class="container" style="padding: 0 1.5rem 4.5rem;">
        <div class="glass-panel" style="padding: 2.5rem; border-top: 3px solid #3b82f6;">
          <div style="margin-bottom: 1.5rem;">
            <span class="badge badge-cyan" style="margin-bottom: 0.5rem;">Engineering & Innovation</span>
            <h3 style="font-size: 1.6rem; color: #fff;">Core Architectural Competencies</h3>
          </div>
          <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 1rem;">
            ${expertiseHtml}
          </div>
        </div>
      </section>

      <!-- Core Works & Interests Breakdown -->
      <section style="background: rgba(255, 255, 255, 0.02); border-top: 1px solid rgba(255, 255, 255, 0.06); padding: 5rem 0;">
        <div class="container">
          <div class="section-header">
            <span class="badge badge-cyan" style="margin-bottom: 0.75rem;">Ecosystem Scope</span>
            <h2>Core Works &amp; Interests</h2>
            <p>How our creative disciplines and engineering tracks reinforce one another in an integrated loop.</p>
          </div>

          <div class="grid grid-2" style="gap: 2rem;">
            
            <div class="glass-panel" style="padding: 2rem; border-top: 3px solid #06d6a0;">
              <div style="display: flex; align-items: center; gap: 0.75rem; margin-bottom: 1rem;">
                <div style="width: 36px; height: 36px; border-radius: 8px; background: #06d6a0; color: #07080d; display: flex; align-items: center; justify-content: center;">
                  <sl-icon name="controller" style="font-size: 1.3rem;"></sl-icon>
                </div>
                <h3 style="font-size: 1.3rem; color: #fff;">1. AtomixGame</h3>
              </div>
              <p style="color: #94a3b8; font-size: 0.92rem; line-height: 1.65;">
                Open-source 3D/2D game frameworks (Atom3D, AtomGdx, AtomixGameEngine) and indie titles on Steam & App Store. Real-time rendering architecture and interactive game simulations.
              </p>
            </div>

            <div class="glass-panel" style="padding: 2rem; border-top: 3px solid #a855f7;">
              <div style="display: flex; align-items: center; gap: 0.75rem; margin-bottom: 1rem;">
                <div style="width: 36px; height: 36px; border-radius: 8px; background: #a855f7; color: #fff; display: flex; align-items: center; justify-content: center;">
                  <sl-icon name="music-note-beamed" style="font-size: 1.3rem;"></sl-icon>
                </div>
                <h3 style="font-size: 1.3rem; color: #fff;">2. AtomixMusics</h3>
              </div>
              <p style="color: #94a3b8; font-size: 0.92rem; line-height: 1.65;">
                Generative AI music, lyric-to-track workflows, and Suno-inspired production tools. Crafting original songs, remixed beats, and reactive game OST soundtracks.
              </p>
            </div>

            <div class="glass-panel" style="padding: 2rem; border-top: 3px solid #f97316;">
              <div style="display: flex; align-items: center; gap: 0.75rem; margin-bottom: 1rem;">
                <div style="width: 36px; height: 36px; border-radius: 8px; background: #f97316; color: #fff; display: flex; align-items: center; justify-content: center;">
                  <sl-icon name="film" style="font-size: 1.3rem;"></sl-icon>
                </div>
                <h3 style="font-size: 1.3rem; color: #fff;">3. AtomixFilms</h3>
              </div>
              <p style="color: #94a3b8; font-size: 0.92rem; line-height: 1.65;">
                AI-driven cinematic short films, dramatic mini-series, and viral shorts for YouTube and TikTok. Where neural cinematography meets speculative worldbuilding.
              </p>
            </div>

            <div class="glass-panel" style="padding: 2rem; border-top: 3px solid #00d2ff;">
              <div style="display: flex; align-items: center; gap: 0.75rem; margin-bottom: 1rem;">
                <div style="width: 36px; height: 36px; border-radius: 8px; background: #00d2ff; color: #07080d; display: flex; align-items: center; justify-content: center;">
                  <sl-icon name="code-slash" style="font-size: 1.3rem;"></sl-icon>
                </div>
                <h3 style="font-size: 1.3rem; color: #fff;">4. AtomixDevs</h3>
              </div>
              <p style="color: #94a3b8; font-size: 0.92rem; line-height: 1.65;">
                Deep technical engineering and "Vibe Coding" methods. Publishing tutorials on fractals, graph neural models, and game engine ECS patterns at <a href="https://atomixnmc.github.io/mydevblog/" target="_blank" rel="noopener noreferrer" style="color: #00d2ff; text-decoration: underline;">mydevblog</a>.
              </p>
            </div>

          </div>
        </div>
      </section>

    </main>

    ${Footer()}
  `;
}
